import axios from 'axios';

const ClientsServices = {
  getClients: async () => {
    const response = await axios.get(`https://reqres.in/api/users`);
    return response.data;
  },
};

export default ClientsServices;
